module.exports = __webpack_public_path__ + "assets/email.e4742db4.svg";